import React from 'react';
import PropTypes from 'prop-types';

import { Button, Section, SectionHeader } from '@lanl-web/lanl-components';

import './OpenPositions.scss';

export const OpenPositions = ({ jobs }) =>
  jobs.length && (
    <Section className='open-positions-section'>
      <SectionHeader
        link='https://lanl.jobs/jobs/?q=SRO-RL'
        linkText='All Library Jobs'
        title='OPEN POSITIONS AT THE LIBRARY'
      />
      <div className='open-positions'>
        <div className='positions-grid'>
          {jobs.map(({ title, url }, index) => (
            <div className='positions-card' key={index}>
              <div className='position-title'>{title}</div>
              <Button href={url} outline color='secondary'>
                LEARN MORE
              </Button>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );

OpenPositions.propTypes = {
  jobs: PropTypes.array,
};

export default OpenPositions;
